// import React from "react";
// import CreateMeetingForm from "./CreateMeetingForm";

// const CreateMeetingDashboard = () => {
//   return (
//     <div className="admin-container">
//       <div className="max-w-xl w-full shadow-lg rounded-lg p-6 space-y-6">
//         <h2 className="text-3xl font-semibold text-gray-800 text-center">Create Session</h2>
//         <CreateMeetingForm />
//       </div>
//     </div>
//   );
// };

// export default CreateMeetingDashboard;

import React, { useEffect, useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import Navbar from "../../components/Navbar";
import TherapistCreateMeetingForm from "./TherapistCreateMeetingForm";
import { useNavigate } from "react-router-dom";

const TherapistCreateMeetingDashboard = () => {
  const navigate = useNavigate();
  // const {
  //     isAdmin,
  //   } = useContext(AuthContext);
  // useEffect(() => {
  //   if (!isAdmin) {
  //     navigate("/", { replace: true });
  //   }
  // }, [isAdmin, navigate]);
  
  
  return (
    <div>
      <Navbar
      />
      <main className="min-h-screen bg-gray-50 pt-24 pb-24 px-4 lg:pl-64">
        <div className="max-w-xl w-full mx-auto bg-white shadow-lg rounded-2xl p-4 sm:p-6 space-y-5">
          <h1 className="text-2xl sm:text-3xl font-semibold text-gray-900">Schedule Session</h1>
          <p className="text-sm text-gray-500">Choose a date and time for this client's session.</p>
          <TherapistCreateMeetingForm />
        </div>
      </main>
    </div>
  );
};

export default TherapistCreateMeetingDashboard;
